import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const PublicChannelClosed = ({ title, text }) => (
  <div className="rounded-2xl border border-amber-200 bg-amber-50 px-5 py-8 text-center">
    <Lock className="mx-auto h-8 w-8 text-amber-700" aria-hidden />
    <h2 className="mt-3 text-lg font-semibold text-amber-950">{title}</h2>
    <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-amber-900/80">{text}</p>
    <Link to="/login" className="btn btn-primary mt-5">
      Entrar no sistema
    </Link>
  </div>
);

export default PublicChannelClosed;
